/**
 * API origin for fetch calls. Paths in this app already include `/api/...`.
 *
 * - Production default: empty string (same-origin `/api/*` via reverse proxy).
 * - Local dev default: empty string so CRA dev-server proxy (package.json "proxy")
 *   forwards `/api/*` to the API on :5001 — required for session cookies to work.
 * - Set REACT_APP_API_BASE_URL=http://localhost:5001 only for split-origin debugging.
 */
export function resolveApiBaseUrl() {
  const configured = process.env.REACT_APP_API_BASE_URL;

  if (configured !== undefined && configured.trim() !== "") {
    return configured.trim().replace(/\/$/, "");
  }

  return "";
}

export const API_BASE_URL = resolveApiBaseUrl();
